import {EPMethod, ProductCustomizationState} from '../../../product/rendering/render.def';
import {DisplayTypeEnum, Inches, RenderV2_DisplayItem, RenderV2Object} from '../render-v2-d';

// SingleDoc hides the document (doc1_visible) and draws the plate in that opening.
// renderV2 then drops the document cell, so the frame shrinks to the rails and the
// document-sized plate covers it. Put the opening back, without the certificate image.
export const withSingleDocOpening = (frame: RenderV2Object, pcs: ProductCustomizationState): RenderV2Object => {
    if (pcs.EPMethodID !== EPMethod.SingleDoc || !pcs.css?.ep_visible) {
        return frame;
    }

    const hasDoc = frame.displayMatrix.some(row => row.some(item => item.displayType === DisplayTypeEnum.Doc));

    if (hasDoc || !(pcs.Document_Width > 0) || !(pcs.Document_Height > 0)) {
        return frame;
    }

    const hasInsignia = frame.displayMatrix.some(row => row.some(item => item.displayType === DisplayTypeEnum.Insignia));
    const opening: RenderV2_DisplayItem = {
        displayType: DisplayTypeEnum.Doc,
        width: pcs.Document_Width as Inches,
        height: pcs.Document_Height as Inches,
        url: '',
        gapRight: -1 as Inches,
        gapBelow: -1 as Inches,
        rowStart: hasInsignia ? 2 : 1,
        columnStart: 1,
    };
    const displayMatrix = frame.displayMatrix.map(row => row.map(item => (item.displayType === DisplayTypeEnum.Lino ? {...item, rowStart: (item.rowStart || 1) + 1} : item)));
    const linoIndex = displayMatrix.findIndex(row => row.some(item => item.displayType === DisplayTypeEnum.Lino));

    if (linoIndex >= 0) {
        displayMatrix.splice(linoIndex, 0, [opening]);
    } else {
        displayMatrix.push([opening]);
    }

    return {...frame, displayMatrix};
};
